import React from 'react'
import styles from './serviceSec.module.css';
import { serviceSlide1Img } from '../../../assets';
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { IMAGE_URL } from '../../helpers/api_helper';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant.jsx';

const ServiceSlides = ({ id, extraClass, count, title, titleAr, descriptionAr, description, disc, badges, img, bgColor, link }) => {
    const { ref: ser1Ref, inView: ser1InView, textAnimation } = useTextAnimation();

    const { t, i18n } = useTranslation();

    return (
        <div className={`${styles.slideOne} ${styles[extraClass]} slide`} id={id} style={{ backgroundColor: bgColor }}>
            <Link to={link}>
                <div className={styles.slideOne_outer}>
                    <div className={styles.slideOne_inner}>
                        <div className={`${styles.slideOne_lftCount} ${i18n.language === LANG_AR ? "arabSerTop" : ''} `}>
                            <motion.h3 ref={ser1Ref}
                                initial="hidden"
                                animate={ser1InView ? "visible" : "hidden"}
                                custom={0}
                                variants={textAnimation}>{count}</motion.h3>
                            <motion.svg ref={ser1Ref}
                                initial="hidden"
                                animate={ser1InView ? "visible" : "hidden"}
                                custom={0}
                                variants={textAnimation} width="565.5" height="15.835" viewBox="0 0 565.5 15.835" preserveAspectRatio="xMidYMax meet">
                                <g id="Group_9421" data-name="Group 9421" transform="translate(-193 -1173.057)">
                                    <line id="Line_40" data-name="Line 40" x2="11.414" y2="6" transform="translate(746.586 1173.5)" fill="none" stroke="#fcfafa" stroke-width="1" />
                                    <line id="Line_41" data-name="Line 41" x1="11.414" y2="9" transform="translate(746.586 1179.5)" fill="none" stroke="#fcfafa" stroke-width="1" />
                                    <line id="Line_45" data-name="Line 45" x2="564.5" transform="translate(193.5 1179.5)" fill="none" stroke="#fcfafa" stroke-linecap="round" stroke-width="1" />
                                </g>
                            </motion.svg>
                            <motion.p ref={ser1Ref}
                                initial="hidden"
                                animate={ser1InView ? "visible" : "hidden"}
                                custom={0}
                                variants={textAnimation}>{t('we')}</motion.p>
                        </div>
                        <div className={`${styles.slideOne_content} ${i18n.language === LANG_AR ? "arabSer" : ''}`}>
                            <div className={`${styles.slideOne_lftDsc} ${i18n.language === LANG_AR ? "arabSerTxt" : ''}`}>
                                <div className={styles.slideOne_lftTxt}>
                                    <motion.h3 ref={ser1Ref}
                                        initial="hidden"
                                        animate={ser1InView ? "visible" : "hidden"}
                                        custom={1}
                                        variants={textAnimation}>
                                        {/* {title} */}
                                        {i18n.language === LANG_EN ? title : titleAr}
                                    </motion.h3>
                                    <motion.p ref={ser1Ref}
                                        initial="hidden"
                                        animate={ser1InView ? "visible" : "hidden"}
                                        custom={2}
                                        variants={textAnimation}
                                        //dangerouslySetInnerHTML={{ __html: disc }}
                                        dangerouslySetInnerHTML={{
                                            __html: i18n.language === LANG_EN ? description : descriptionAr
                                        }}
                                    >
                                    </motion.p>
                                </div>
                                <div className={`${styles.slideOne_lftPoints} ${i18n.language === LANG_AR ? "fltRgt" : ''}`}>
                                    <ul className={`${styles.slideOne_lftPoin} ${i18n.language === LANG_AR ? "arabSerBag" : ''}`}>
                                        {badges.map((badge, id) => (
                                            <li key={id}>
                                                <div className={styles.slideOne_lftPoinIcon}>
                                                    <motion.p ref={ser1Ref}
                                                        initial="hidden"
                                                        animate={ser1InView ? "visible" : "hidden"}
                                                        custom={3}
                                                        variants={textAnimation}>
                                                        {/*  {badge.feature} */}
                                                        {i18n.language === LANG_EN ? badge.feature : badge.featureAr}
                                                    </motion.p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className={styles.slideOne_rgtDsc}>
                                <img src={`${IMAGE_URL}/whatWeDo/${img}`} alt="" loading='lazy' />
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default ServiceSlides
    